import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import auth from 'lib/authentication';
import { getActiveStudent } from 'helpers/guardian';
var configSettings = require('../../app-config/config');
var config = configSettings.GET_CONFIG();
var http = axios.create({
  baseURL: config.API + "/api"
});
function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
var interceptor = http.interceptors.response.use(function (response) {
  if (response.status == 204) {
    response.data = null;
  }
  return response;
}, function (error) {
  var response = error.response;
  // If response status is 0, retry logic
  if (response && response.status === 0) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        // Dispatch an error (toast bar) first retry
        if (!error.config.headers['Retries']) {
          _addToast("You seem to have lost connection to the server. You can keep working as usual while we're trying to reconnect you.");
          error.config.headers['Retries'] = '1';
        } else {
          error.config.headers['Retries'] = (parseInt(error.config.headers['Retries']) + 1).toString();
        }
        // Stop retrying after 50 attempts
        if (parseInt(error.config.headers['Retries']) > 49) {
          return resolve(Promise.reject(error));
        }
        resolve(http.request(error.config));
      }, 1000); // Wait for 1 second before retrying
    });
  }
  return Promise.reject(error);
});

/**
 * @param {import('history').History} history - from useHistory() hook
 */
export var setupInterceptors = function setupInterceptors(history) {
  http.interceptors.request.use( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var token, studentId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (config.allowAnonymous) {
              _context.next = 15;
              break;
            }
            _context.next = 3;
            return auth.getAccessToken();
          case 3:
            token = _context.sent;
            if (!(token != null)) {
              _context.next = 8;
              break;
            }
            config.headers.common['Authorization'] = "Bearer " + token;
            _context.next = 9;
            break;
          case 8:
            return _context.abrupt("return", Promise.reject("Token is not valid"));
          case 9:
            studentId = getActiveStudent();
            if (config.params == null) {
              config.params = {};
            }
            if (studentId != null) config.params['studentId'] = studentId;
            return _context.abrupt("return", config);
          case 15:
            return _context.abrupt("return", config);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), function (error) {
    Promise.reject(error);
  });
};

// Export members
export default http;